
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world",
      function () {
        return require("private-next-pages/world/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world"])
      });
    }
  